var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{attrs:{"aria-label":"Page navigation example"}},[_c('b-pagination',{staticClass:"pagination justify-content-center mt-3",attrs:{"total-rows":_vm.Validate,"perPage":_vm.FiltroP.Entrada,"size":"sm"},model:{value:(_vm.CurrentPage),callback:function ($$v) {_vm.CurrentPage=$$v},expression:"CurrentPage"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }